import { combineReducers, } from 'redux'
import { routerReducer, } from 'react-router-redux'
import appBarReducer from './appBar'
import articleReducer from './articles'
import authReducer from './auth'
import cacheIndexReducer from './cacheIndex'
import counterStrikeGlobalOffensiveReducer from './counterStrikeGlobalOffensive'
import currentGamerProfileReducer from './currentGamerProfile'
import currentGamerPurchaseProfileReducer from './currentGamerPurchaseProfile'
import currentGamerReducer from './currentGamer'
import dialogReducer from './dialog'
import flickPowerRankingCountReducer from './flickPowerRankingCount'
import flickPowerRankingReducer from './flickPowerRankings'
import followThroughPowerRankingCountReducer from './followThroughPowerRankingCount'
import followThroughPowerRankingReducer from './followThroughPowerRankings'
import fortnitePowerRankingCountReducer from './fortnitePowerRankingCount'
import fortnitePowerRankingReducer from './fortnitePowerRankings'
import gameInterfaceReducer from './gameInterface'
import gamerReducer from './gamers'
import gameSoundReducer from './gameSounds'
import mobilePowerRankingCountReducer from './mobilePowerRankingCount'
import mobilePowerRankingReducer from './mobilePowerRankings'
import overallStatisticsReducer from './overallStatistics'
import otherGamerReducer from './otherGamer'
import otherGamerProfileReducer from './otherGamerProfile'
import powerRankingCountReducer from './powerRankingCount'
import powerRankingReducer from './powerRankings'
import purchaseReducer from './purchases'
import routeParamsReducer from './routeParams'
import scoreReducer from './scores'
import snackbarReducer from './snackbar'
import speedPowerRankingCountReducer from './speedPowerRankingCount'
import speedPowerRankingReducer from './speedPowerRankings'
import trackingPowerRankingCountReducer from './trackingPowerRankingCount'
import trackingPowerRankingReducer from './trackingPowerRankings'
import userInterfaceReducer from './userInterface'
import weeklyStatisticsReducer from './weeklyStatistics'

const rootReducer = combineReducers({
  appBar: appBarReducer,
  articles: articleReducer,
  auth: authReducer,
  cacheIndex: cacheIndexReducer,
  counterStrikeGlobalOffensive: counterStrikeGlobalOffensiveReducer,
  currentGamer: currentGamerReducer,
  currentGamerProfile: currentGamerProfileReducer,
  currentGamerPurchaseProfile: currentGamerPurchaseProfileReducer,
  dialog: dialogReducer,
  flickPowerRankingCount: flickPowerRankingCountReducer,
  flickPowerRankings: flickPowerRankingReducer,
  followThroughPowerRankingCount: followThroughPowerRankingCountReducer,
  followThroughPowerRankings: followThroughPowerRankingReducer,
  fortnitePowerRankingCount: fortnitePowerRankingCountReducer,
  fortnitePowerRankings: fortnitePowerRankingReducer,
  gameInterface: gameInterfaceReducer,
  gamers: gamerReducer,
  gameSounds: gameSoundReducer,
  mobilePowerRankingCount: mobilePowerRankingCountReducer,
  mobilePowerRankings: mobilePowerRankingReducer,
  overallStatistics: overallStatisticsReducer,
  otherGamer: otherGamerReducer,
  otherGamerProfile: otherGamerProfileReducer,
  powerRankingCount: powerRankingCountReducer,
  powerRankings: powerRankingReducer,
  purchases: purchaseReducer,
  routing: routerReducer,
  routeParams: routeParamsReducer,
  scores: scoreReducer,
  snackbar: snackbarReducer,
  speedPowerRankingCount: speedPowerRankingCountReducer,
  speedPowerRankings: speedPowerRankingReducer,
  trackingPowerRankingCount: trackingPowerRankingCountReducer,
  trackingPowerRankings: trackingPowerRankingReducer,
  userInterface: userInterfaceReducer,
  weeklyStatistics: weeklyStatisticsReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/app/reducers/index.js